module.exports = __webpack_public_path__ + "static/media/arrow-right-black.d57a7392.svg";